import { request } from "http";
import apiClient from "../../../api/apiClient";
import { PaginationRequest } from "../../../models/Request/apiDateFormatRequest";
import { UnifiedResponse } from "../../../models/Response/unifiedResponse";
import {
  BonusRequest,
  ActiveBonusRetrieveListRequest,
  BonusStatusRequest,
  ActivateFreeSpinBonusUserWiseRequest,
  CheckAndActivateCashdropBonusRequest,
  BonusTurnOverDetailsRequest,
  BonusHistoryByDateRequest,
} from "../models/requests/index";
import {
  RetriveAllConsumedBonusResponseDetails,
  BonusRetrieveListResponse,
  FreeSpinBonusListResponseDetails,
  BonusTurnOverDetailsListResponse,
  BonusDetailPerDayResponseDetails
} from "../models/responses/index";
import { IncludeExcludeProvidersGamesResponse } from "../models/responses/includeExcludeProvidersGamesResponse";

export const bonusApi = {
  retriveAllCancelledBonusListApi: async (
    request: PaginationRequest,
  ): Promise<UnifiedResponse<RetriveAllConsumedBonusResponseDetails>> => {
    const response = await apiClient.post<
      UnifiedResponse<RetriveAllConsumedBonusResponseDetails>
    >("bonus/retrieve_all_cancelled_bonus/list", request);
    return response.data;
  },
  retriveAllExpiredBonusListApi: async (
    request: PaginationRequest,
  ): Promise<UnifiedResponse<RetriveAllConsumedBonusResponseDetails>> => {
    const response = await apiClient.post<
      UnifiedResponse<RetriveAllConsumedBonusResponseDetails>
    >("bonus/retrieve_all_Expired_bonus/list", request);
    return response.data;
  },
  retriveAllConsumedBonusList: async (
    request: PaginationRequest,
  ): Promise<UnifiedResponse<RetriveAllConsumedBonusResponseDetails>> => {
    const response = await apiClient.post<
      UnifiedResponse<RetriveAllConsumedBonusResponseDetails>
    >("bonus/retrieve_all_consumed_bonus/list", request);
    return response.data;
  },
  activateCashdrop: async (
    request: BonusRequest,
  ): Promise<UnifiedResponse<unknown>> => {
    const response = await apiClient.post<UnifiedResponse<unknown>>(
      "bonus/ActivateCashdrop",
      request,
    );
    return response.data;
  },
  activeBonusRetrieveListApi: async (
    request: ActiveBonusRetrieveListRequest,
  ): Promise<UnifiedResponse<BonusRetrieveListResponse>> => {
    const response = await apiClient.post<
      UnifiedResponse<BonusRetrieveListResponse>
    >("bonus/active_bonus/list", request);
    return response.data;
  },
  freespinBonusRetrieveListApi: async (
    request: BonusStatusRequest,
  ): Promise<UnifiedResponse<FreeSpinBonusListResponseDetails>> => {
    const response = await apiClient.post<
      UnifiedResponse<FreeSpinBonusListResponseDetails>
    >("bonus/free_spin/retrieve", request);
    return response.data;
  },
  checkAndActivateFreeSpinBonus: async (
    request: ActivateFreeSpinBonusUserWiseRequest,
  ): Promise<UnifiedResponse<unknown>> => {
    const response = await apiClient.post<UnifiedResponse<unknown>>(
      "bonus/activatefreespinbonus/byuserid",
      request,
    );
    return response.data;
  },

  checkAndActivateCashdropBonus: async (
    request: CheckAndActivateCashdropBonusRequest,
  ): Promise<UnifiedResponse<unknown>> => {
    const response = await apiClient.post<UnifiedResponse<unknown>>(
      "bonus/activatecashdropbonus/byuserid",
      request,
    );
    return response.data;
  },
  checkAndActivateCashbackWinningBoost: async(
    id:string
  ):Promise<UnifiedResponse<unknown>> =>{
    const response = await apiClient.post<UnifiedResponse<unknown>>(
        "bonus/ActivateCashbackWinningBoost",
        {id}
    );
    return response.data;
  },
  updateUsersFreeSpinCancellation: async (): Promise<
    UnifiedResponse<unknown>
  > => {
    const response = await apiClient.post<UnifiedResponse<unknown>>(
      "bonus/UpdateUsersFreeSpinCancellation",
      {},
    );
    return response.data;
  },
  bonusTurnOverRetrieveListApi: async (
    request: BonusTurnOverDetailsRequest,
  ): Promise<UnifiedResponse<BonusTurnOverDetailsListResponse>> => {
    const response = await apiClient.post<
      UnifiedResponse<BonusTurnOverDetailsListResponse>
    >("bonus/user_bonus_turnover_history/list", request);
    return response.data;
  },
  exchangeBonusTurnOverRetrieveListApi: async (
    request: BonusTurnOverDetailsRequest,
  ): Promise<UnifiedResponse<BonusTurnOverDetailsListResponse>> => {
    const response = await apiClient.post<
      UnifiedResponse<BonusTurnOverDetailsListResponse>
    >("bonus/user_exchange_bonus_turnover_history/list", request);
    return response.data;
  },
  sportsBonusTurnOverRetrieveListApi: async (
    request: BonusTurnOverDetailsRequest,
  ): Promise<UnifiedResponse<BonusTurnOverDetailsListResponse>> => {
    const response = await apiClient.post<
      UnifiedResponse<BonusTurnOverDetailsListResponse>
    >("bonus/user_sports_bonus_turnover_history/list", request);
    return response.data;
  },
  onIncludeExcludeProviderGame: async (
    id: string | null,
  ): Promise<UnifiedResponse<IncludeExcludeProvidersGamesResponse>> => {
    const response = await apiClient.post<
      UnifiedResponse<IncludeExcludeProvidersGamesResponse>
    >("bonus/IncludeExcludeProvidersGames", { id });
    return response.data;
  },
  activateCashbackAndWinningBoost:async (AccessMode:number | null):Promise<UnifiedResponse<unknown>> => {
    const response = await apiClient.post<
      UnifiedResponse<unknown>
    >("bonus/ActivateCashbackAndWinningBoost", {AccessMode});
    return response.data;
  },
  retrieveUsersBonusByDate: async(request:BonusHistoryByDateRequest):Promise<UnifiedResponse<BonusDetailPerDayResponseDetails>> =>{
    const response = await apiClient.post<UnifiedResponse<BonusDetailPerDayResponseDetails>>("bonus/retrieve_users_bonus_by_date/list",request);
    return response.data;
  },
  cancelDepositBonus: async (
    request: BonusRequest,
  ): Promise<UnifiedResponse<unknown>> => {
    const response = await apiClient.post<UnifiedResponse<unknown>>(
      "bonus/cancel_bonus/status_update",
      request,
    );
    return response.data;
  },
};
